export enum OwnerType {
  TRUST_OWNER = "TRUST_OWNER",
}
